import React from 'react';
import PropTypes from 'prop-types';
import './PageDescription.scss';

const PageDescription = ({children, ...props}) => (
  <div className="page-description" {...props}>
    {children}
  </div>
);

PageDescription.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageDescription;
